import { TenantEntity } from '../TenantEntity'
import { isContractExpiredForbidCreateJob } from '@/api/partner/contract'

export class Contract extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get contractNo() {
    return this._data.contractNo
  }
  set contractNo(contractNo) {
    this._data.contractNo = contractNo
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get contractType() {
    return this._data.contractType
  }
  set contractType(contractType) {
    this._data.contractType = contractType
  }
  get contractState() {
    return this._data.contractState
  }
  set contractState(contractState) {
    this._data.contractState = contractState || 0
  }
  get contractAgreement() {
    return this._data.contractAgreement
  }
  set contractAgreement(contractAgreement) {
    this._data.contractAgreement = contractAgreement || 0
  }
  get creditDateType() {
    return this._data.creditDateType
  }
  set creditDateType(creditDateType) {
    this._data.creditDateType = creditDateType || 0
  }
  get dateType() {
    return this._data.dateType
  }
  set dateType(dateType) {
    this._data.dateType = dateType
  }
  get dateLimited() {
    return this._data.dateLimited
  }
  set dateLimited(dateLimited) {
    this._data.dateLimited = dateLimited || 0
  }
  get termUnit() {
    return this._data.termUnit
  }
  set termUnit(termUnit) {
    this._data.termUnit = termUnit || 0
  }
  get credit() {
    return this._data.credit
  }
  set credit(credit) {
    this._data.credit = credit || 0.0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get postpone() {
    return this._data.postpone
  }
  set postpone(postpone) {
    this._data.postpone = postpone
  }
  get postponeLimited() {
    return this._data.postponeLimited
  }
  set postponeLimited(postponeLimited) {
    this._data.postponeLimited = postponeLimited
  }
  get postponeUnit() {
    return this._data.postponeUnit
  }
  set postponeUnit(postponeUnit) {
    this._data.postponeUnit = postponeUnit
  }
  get postponeType() {
    return this._data.postponeType
  }
  set postponeType(postponeType) {
    this._data.postponeType = postponeType
  }
  get isNeedSyshcronize() {
    return this._data.isNeedSyshcronize
  }
  set isNeedSyshcronize(isNeedSyshcronize) {
    this._data.isNeedSyshcronize = isNeedSyshcronize
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }

  /* 拓展属性===========================*/
  // 合作伙伴ID
  get partnerId() {
    return this._data.partnerId
  }
  set partnerId(partnerId) {
    this._data.partnerId = partnerId
  }
  // 客户级别
  get customerType() {
    return this._data.customerType
  }
  set customerType(customerType) {
    this._data.customerType = customerType
  }
  // UUID
  get contractUuid() {
    return this._data.contractUuid
  }
  set contractUuid(contractUuid) {
    this._data.contractUuid = contractUuid
  }
  get clearCreditAtExpire() {
    return this._data.clearCreditAtExpire
  }
  set clearCreditAtExpire(clearCreditAtExpire) {
    this._data.clearCreditAtExpire = clearCreditAtExpire || false
  }
  get contractBatchNo() {
    return this._data.contractBatchNo
  }
  set contractBatchNo(contractBatchNo) {
    this._data.contractBatchNo = contractBatchNo
  }
  get associationList() {
    return this._data.associationList
  }
  set associationList(associationList) {
    this._data.associationList = associationList
  }
  get snapCredit() {
    return this._data.snapCredit
  }
  set snapCredit(snapCredit) {
    this._data.snapCredit = snapCredit || 0
  }
  get snapCreditDateLimited() {
    return this._data.snapCreditDateLimited
  }
  set snapCreditDateLimited(snapCreditDateLimited) {
    this._data.snapCreditDateLimited = snapCreditDateLimited || 0
  }
  get paymentTerm() {
    return this._data.paymentTerm
  }
  set paymentTerm(paymentTerm) {
    this._data.paymentTerm = paymentTerm || 0
  }
  // 是否禁止到期合同创建业务
  static async isContractExpiredForbidCreateJob(cmpIdx) {
    return await isContractExpiredForbidCreateJob({ cmpIdx }).then(res => res.data)
  }
}
